import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getNodeQueryKey, getNodesQueryKey } from 'hooks/queries/nodes';
import { useCurrentOrganizationId } from '@cast/infrastructure-organization';

type Args = {
  clusterId: string;
  nodeName: string;
  nodeId: string;
};

export const useKentDrainNodeMutation = () => {
  const organizationId = useCurrentOrganizationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clusterId, nodeName }: Args) =>
      apiClient.kent.drainNode({
        organizationId,
        clusterId,
        nodeName,
        drainNodeRequest: {
          organizationId,
          clusterId,
          nodeName,
        },
      }),
    onSuccess: (_, { clusterId, nodeId }) => {
      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getNodeQueryKey({ clusterId, nodeId }),
      });
    },
  });
};
